import { Scrollbars } from "react-custom-scrollbars-2";
import classes from "./App.module.css";
import { useState, useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LayoutWrapper from "./components/LayoutWrapper/LayoutWrapper";

import LandingPage from "./Pages/LandingPage/LandingPage";
import SignUpPage from "./Pages/Signup/Signup";


import LoginPage from "./Pages/SignInPage/SignInPage";

import SalesModule from "./Pages/SalesModulePage/SalesModule";
import StockModule from "./Pages/StockModulePage/StockModule";
import PurchaseModule from "./Pages/PurchaseModulePage/StockModule";
import GateControl from "./Pages/GateControlPage/StockModule";
import FinanceModule from "./Pages/FinanceModulePage/StockModule";
import ProductionModule from "./Pages/ProductionModulePage/StockModule";
import Transporter from "./Pages/Transporter/StockModule";
import Jobwork from "./Pages/Jobwork/StockModule";
import Payroll from "./Pages/payRoll/StockModule";
import Administrator from "./Pages/AdministratorModulePage/AdministratorModule";
import Ab from "./Pages/CustomLayout/LayoutContainer"
import Otp from "./Pages/Otp/Otp";
import Plan from "./Pages/Plan/Plan";
import Contact from "./Pages/Contact/Contact";
import About from "./Pages/About/About";
import Terms from "./Pages/TermndCondition/Term";
import Privacy from "./Pages/Privacy/Privacy";
import Cancle from "./Pages/Cancel/Cancle";



//https://metalzulu-backend.onrender.com
//http://localhost:8005dfdfd
function App() {
  const AURL = "https://metalzulu-backend.onrender.com";
  const [company, setCompany] = useState(null);
  const [site, setSite] = useState(null);
  const [finYear, setFinYear] = useState(null);
  const [type, setType] = useState("");
  const [userTypes, setUserTypes] = useState(null);
  const [analysis, setAnalysis] = useState(null);
  const [companyTypes, setCompanyTypes] = useState(null);
  const [siteTypes, setSiteTypes] = useState(null);

  //const [analysisV, setAnalysisV] = useState(null)
  const history = useNavigate();

  useEffect(() => {
    // axios
    //   .get(AURL + "/api/v1/users/finYearModule", {
    //     withCredentials: true,
    //   })

    //   .then((response) => {
    

  
    //     setFinYear(response.data.data.finYears);
      
    //   });

    // axios
    //   .get(AURL + "/api/v1/users/companyModule", {
    //     withCredentials: true,
    //   })

    //   .then((response) => {
       

    //     setCompanyTypes(response.data.data.companys);
       
    //   });

    // axios
    //   .get(AURL + "/api/v1/users/siteModule", {
    //     withCredentials: true,
    //   })

    //   .then((response) => {
       

    //     setSiteTypes(response.data.data.site);
       
    //   });

   

    // axios
    //   .get(AURL + "/api/v1/users/getUserType", {
    //     withCredentials: true,
    //   })

    //   .then((response) => {
   

    //     setUserTypes(response.data.data.userTypes);
   
    //   });

    axios
      .get(AURL + "/api/v1/users/checkStatus", {
        withCredentials: true,
      })
      .then((responseA) => {
        console.log(responseA);

        if (responseA.data.data) {
          if (responseA.data.data.user.rows[0].userType === "employee") {
            axios
              .get(AURL + "/api/v1/cns", { withCredentials: true })
              .then((response) => {
                // console.log(response);
                const index = response.data.data.companies.findIndex(
                  (element) =>
                    element.company_code ===
                    responseA.data.data.user.rows[0].company_code
                );
                setCompany({
                  code: responseA.data.data.user.rows[0].company_code,
                  name: response.data.data.companies[index].company_name,
                });
                // console.log(company);
                const index2 = response.data.data.sites.findIndex(
                  (element) =>
                    element.site_code ===
                    responseA.data.data.user.rows[0].unit_code
                );
                setSite({
                  code: responseA.data.data.user.rows[0].unit_code,
                  name: response.data.data.sites[index2].site_desc,
                });
              })
              .catch((err) => {
                // console.log(err);
              });
          }
          if (responseA.data.data.user.rows[0].userType === "erp") {
            axios
              .get(AURL + "/api/v1/cns", { withCredentials: true })
              .then((response) => {
                const index = response.data.data.companies.findIndex(
                  (element) =>
                    element.COMPANY_CODE ===
                    responseA.data.data.user.rows[0].COMPANY_CODE
                );
                setCompany({
                  code: responseA.data.data.user.rows[0].COMPANY_CODE,
                  name: response.data.data.companies[index].COMPANY_NAME,
                });

                const index2 = response.data.data.sites.findIndex(
                  (element) =>
                    element.SITE_CODE ===
                    responseA.data.data.user.rows[0].UNIT_CODE
                );
                setSite({
                  code: responseA.data.data.user.rows[0].UNIT_CODE,
                  name: response.data.data.sites[index2].SITE_DESC,
                });
              })
              .catch((err) => {
                // console.log(err);
              });
          }

          if (responseA.data.data.user.rows[0].userType === "sales") {
            setAnalysis(null);
            axios
              .get(AURL + "/api/v1/dashboard/dash-board", {
                withCredentials: true,
              })
              .then((response) => {
                // console.log(response);
                setAnalysis((analysis) => {
                  let newAnalysis = response.data.data;
                  return newAnalysis;
                });
              })
              .catch((err) => {
                // console.log(err);
              });
          }

          // if(responseA.data.data.user.rows[0].userType === "vendor"){
          //   axios
          //   .get(AURL + '/api/v1/vendor/analysis',{withCredentials: true})
          //   .then((response) => {

          //     setAnalysisV((analysisV) => {
          //       let newAnalysis = response.data.data
          //       return newAnalysis
          //     })

          //   })
          //   .catch((err) => {
          //     // console.log(err);
          //   });
          // }.

          if (
            responseA.data.data.user.rows[0].userType !== "customer" &&
            window.location.href.split("/")[3] === "customer-portal"
          ) {
            history.replace("/customer");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }

          if (
            responseA.data.data.user.rows[0].userType !== "vendor" &&
            window.location.href.split("/")[3] === "vendor-portal"
          ) {
            history("/vendor");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }

          if (
            responseA.data.data.user.rows[0].userType !== "employee" &&
            window.location.href.split("/")[3] === "reports"
          ) {
            history("/employee");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }

          if (
            responseA.data.data.user.rows[0].userType !== "payroll" &&
            window.location.href.split("/")[3] === "payroll"
          ) {
            history("/employee");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }

          if (
            responseA.data.data.user.rows[0].userType !== "sales" &&
            window.location.href.split("/")[3] === "SalesModule"
          ) {
            history("/employee");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }
        } else {
          console.log(window.location.href.split("/")[3]);
          if (
            window.location.href.split("/")[3] !== "employee" &&
            window.location.href.split("/")[3] !== "login" &&
            window.location.href.split("/")[3] === "reports"
          ) {
            history("/employee");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          } else if (
            window.location.href.split("/")[3] !== "employee" &&
            window.location.href.split("/")[3] !== "login" &&
            window.location.href.split("/")[3] === "payroll"
          ) {
            history("/employee");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          } else if (
            window.location.href.split("/")[3] !== "erp" &&
            window.location.href.split("/")[3] !== "login" &&
            window.location.href.split("/")[3] === "erp"
          ) {
            history("/erp");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          } else if (
            window.location.href.split("/")[3] !== "customer" &&
            window.location.href.split("/")[3] !== "loginC" &&
            window.location.href.split("/")[3] === "customer-portal"
          ) {
            history("/customer");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          } else if (
            window.location.href.split("/")[3] !== "vendor" &&
            window.location.href.split("/")[3] !== "loginV" &&
            window.location.href.split("/")[3] === "vendor-portal"
          ) {
            history("/vendor");
            message.error({
              content: "Sign In to gain Access!!!!",
              className: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  }, []);



  return (
    <Scrollbars className={classes["App"]}>
      <LayoutWrapper>
        <Routes>
          <Route exact path="/lov" Lov type={type} setType={setType} />

          <Route
            exact
            path="/ab"
            element={
              <Ab />
            }
          />

           <Route
            exact
            path="/otp"
            element={
              <Otp/>
            }
          />


            <Route
            exact
            path="/contact-us"
            element={
              <Contact/>
            }
          />

<Route
            exact
            path="/terms-and-conditions"
            element={
              <Terms/>
            }
          />


<Route
            exact
            path="/privacy-policy"
            element={
              <Privacy/>
            }
          />


<Route
            exact
            path="/cancellation-refund-policy"
            element={
              <Cancle/>
            }
          />

<Route
            exact
            path="/about-us"
            element={
              <About/>
            }
          />

          <Route
            exact
            path="/"
            element={
              <LandingPage type={type} setType={setType} finYear={finYear} />
            }
          />
           <Route
            exact
            path="/signup"
            element={
              <SignUpPage />
            }
          />

          <Route
            exact
            path="/login"
            element={
             
                <LoginPage
                  url={AURL}
                  
                />
              
            }
          />

          <Route
            path="/sales*"
            element={
              // analysis ? (
              <SalesModule
                url={AURL}
                finYear={finYear}
                analysis={analysis}
                setAnalysis={setAnalysis}
              />
              // )
              // : (
              //   // Render a loading component or a placeholder while waiting for data
              //   <>
              //     <div
              //       style={{
              //         display: "flex",
              //         flexDirection: "column",
              //         alignItems: "center",
              //         justifyContent: "center",
              //         height: "100vh",
              //         background: "#F0E5F3", // Set your desired background color
              //       }}
              //     >
              //       <h1 style={{ color: "white" }}>Welcome to Mini Erp</h1>
              //     </div>
              //   </>
              // )
            }
          />

          <Route
            path="/stock*"
            element={<StockModule url={AURL} finYear={finYear} />}
          />

          <Route
            path="/purchase*"
            element={<PurchaseModule url={AURL} finYear={finYear} />}
          />

          <Route
            path="/production*"
            element={<ProductionModule url={AURL} finYear={finYear} />}
          />

          <Route
            path="/finance*"
            element={<FinanceModule url={AURL} finYear={finYear} />}
          />

          <Route
            path="/gate*"
            element={<GateControl url={AURL} finYear={finYear} />}
          />

          <Route
            path="/transporter*"
            element={<Transporter url={AURL} finYear={finYear} />}
          />
          <Route
            path="/jobwork*"
            element={<Jobwork url={AURL} finYear={finYear} />}
          />
          
          <Route
            path="/payroll*"
            element={<Payroll url={AURL} finYear={finYear} />}
          />
          <Route
            path="/admin*"
            element={<Administrator url={AURL} finYear={finYear} />}
          />
          <Route
            path="/Plan*"
            element={<Plan url={AURL} finYear={finYear} />}
          />
          
        </Routes>
      </LayoutWrapper>
    </Scrollbars>
  );
}

export default App;
